import { ComplexBase } from '@syncfusion/ej2-react-base';
export class MenuItemDirective extends ComplexBase {
}
MenuItemDirective.moduleName = 'menuItem';
export class MenuItemsDirective extends ComplexBase {
}
MenuItemsDirective.propertyName = 'items';
MenuItemsDirective.moduleName = 'menuItems';
